import { createSlice } from '@reduxjs/toolkit'
import reducers from 'store/features/credits/reducers'
import { getInitialState } from 'store/features/credits/initialState'

const creditsSlice = createSlice({
  name: 'credits',
  initialState: getInitialState(),
  reducers
})

export default creditsSlice
